import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import SmallUserProfile from "../components/SmallUserProfile";
import Grid from "@material-ui/core/Grid";
import { Box } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  header: {
    paddingLeft: 60,
    [theme.breakpoints.up("xl")]: {
      paddingLeft: 0,
    },
  },
}));

const ApplicationHeader = props => {
  const { applicationNavigation } = props;
  const classes = useStyles();

  return (
    <Container className={classes.header} disableGutters>
      <Box mb={4}>
        <Grid container justify="space-between" alignItems="center">
          {applicationNavigation ? (
            <Grid item sm={true}>
              {applicationNavigation}
            </Grid>
          ) : (
            <Box>{/*  Empty div to fill navigation space */}</Box>
          )}

          <Grid item>
            <SmallUserProfile />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default ApplicationHeader;
